
import {Component, Prop, Vue} from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import {BorcluEntity} from "@/entity/BorcluEntity";
import NotList from "@/components/lists/NotList.vue";
import {NotTuru} from "@/enum/NotTuru";
import HacizTalepForm from "@/components/forms/haciz/HacizTalepForm.vue";
import {HacizTalebiEntity} from "@/entity/Haciz/HacizTalebiEntity";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";

@Component({
  components: {DeleteDialog, HacizTalepForm, NotList, FormDialog}
})
export default class HacizTalepList extends Vue {
  @Prop() borclu!: BorcluEntity;
  @Prop() uyapBilgileri!: any;
  notTuru = NotTuru;

  headers = [
    {text: "Türler", align: "start", value: "haciz_turleri"},
    {text: "Tarih", align: "start", value: "haciz_tarihi"},
    {text: "Talep Tutarı", align: "start", value: "talep_tutari"},
    {text: "İşlemler", value: "actions", width: 150, sortable: false, align: 'center'},
  ];

  get defaultHacizTalebi() {
    let hacizTalepObj = new HacizTalebiEntity();
    return hacizTalepObj;
  }

  load() {
    this.$emit('load');
  }

  async onHacizTalepEditClick(item: any) {
    if (!item.id) return;
    try {
      const response = await this.$http.get('/api/v1/haciz-talep/' + item.id + '/hacizler');
      const hacizler = Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
      item.hacizler = hacizler;
    } catch (e: any) {
      this.$toast?.error('Haciz verileri yüklenemedi: ' + (e?.message || e));
    }
  }

  getHacizTarihi(haciz: any): string | null {
    return haciz?.ekstra_data?.haciz_tarihi ?? null;
  }

  tumHacizlerAyniTarih(item: HacizTalebiEntity): boolean {
    const hacizler = item.hacizler || [];
    if (hacizler.length <= 1) return true;
    const ilkTarih = this.getHacizTarihi(hacizler[0]);
    return hacizler.every(h => this.getHacizTarihi(h) === ilkTarih);
  }
}
